import React from 'react';
import { motion } from 'framer-motion';
import { MolecularBackdrop } from '../components/MolecularBackdrop';
import { Linkedin, MapPin, RotateCcw, Mail } from 'lucide-react';
interface Props {
  onReset: () => void;
  onOpenMap: () => void;
}
export function SlideThanks({
  onReset,
  onOpenMap
}: Props) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.8,
    ease: 'easeOut'
  }} className="flex-1 flex flex-col relative px-5 pt-20 pb-6" data-id="element-666">
      <MolecularBackdrop variant="bloom" data-id="element-667" />

      <div className="relative z-10 flex-1 flex flex-col justify-center items-center text-center" data-id="element-668">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="mb-7" data-id="element-669">
          <h2 className="text-[28px] font-display font-bold text-slate-900 leading-tight mb-3" data-id="element-670">
            Thank you for sharing your perspective
          </h2>
          <button onClick={onOpenMap} className="inline-flex items-center gap-2 text-minerva-cyan text-base font-semibold hover:text-minerva-blue transition-colors" data-id="element-671">
            <MapPin size={16} data-id="element-672" />
            <span className="underline underline-offset-4" data-id="element-673">
              Meet us at Booth #1762
            </span>
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="w-full max-w-xs mb-6" data-id="element-674">
          <div className="rounded-2xl bg-white p-2 shadow-[0_20px_60px_-15px_rgba(0,133,189,0.3)] border border-slate-200" data-id="element-675">
            <img src="https://cdn.magicpatterns.com/uploads/bsyhX5a5mEnChrC5VPSx7c/Screenshot_2026-05-12_at_11.29.04.png" alt="SNMMI 2026 Annual Meeting · Los Angeles · May 30 – June 2" className="w-full h-auto rounded-xl" data-id="element-676" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.7
      }} className="w-full flex flex-col gap-2.5 max-w-xs" data-id="element-677">
          <a href="https://www.linkedin.com/company/minerva-imaging" target="_blank" rel="noreferrer" className="w-full h-14 flex items-center justify-center gap-3 bg-minerva-blue text-white rounded-xl font-semibold hover:bg-minerva-cyan hover:text-slate-900 transition-colors shadow-[0_8px_24px_-6px_rgba(0,133,189,0.5)]" data-id="element-678">
            <Linkedin size={20} data-id="element-679" />
            Follow Minerva
          </a>

          <a href="mailto:BD@minervaimaging.com" className="w-full h-14 flex items-center justify-center gap-2 bg-white border border-slate-200 text-slate-900 rounded-xl font-medium hover:border-minerva-blue/40 hover:bg-slate-50 transition-colors" data-id="element-680">
            <Mail size={16} className="text-minerva-blue" data-id="element-681" />
            <span className="text-sm" data-id="element-682">BD@minervaimaging.com</span>
          </a>
        </motion.div>
      </div>

      <motion.button initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 2
    }} onClick={onReset} className="relative z-10 flex items-center justify-center gap-2 text-slate-400 hover:text-slate-700 text-[10px] uppercase tracking-widest mt-auto py-3 transition-colors" data-id="element-683">
        <RotateCcw size={12} data-id="element-684" />
        Start over
      </motion.button>
    </motion.div>;
}